import { render, staticRenderFns } from "./commandes_aexpedier.vue?vue&type=template&id=5394a608&"
import script from "./commandes_aexpedier.vue?vue&type=script&lang=js&"
export * from "./commandes_aexpedier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports